import React, { useEffect, useMemo, useState } from "react";
import "../../styles/theme-dark.css";
import "../Clientes.css";
import axios from "../../api/axios";
import { useNavigate, useParams } from "react-router-dom";

const formatEuro = (n) =>
  new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n) || 0) + " €";

export default function CompraPagos() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [compra, setCompra] = useState(null);
  const [pagos, setPagos] = useState([]);
  const [importe, setImporte] = useState("");
  const [fecha, setFecha] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const res = await axios.get(`/compras/${id}`);
    setCompra(res.data);
    setPagos(res.data.pagos || []);
  };

  useEffect(() => {
    load();
  }, [id]);

  const totalPagado = useMemo(
    () => pagos.reduce((acc, p) => acc + (Number(p.importe) || 0), 0),
    [pagos]
  );

  const pendiente = useMemo(() => {
    if (!compra) return 0;
    return Number(compra.total) - totalPagado;
  }, [compra, totalPagado]);

  const addPago = async () => {
    if (!importe) {
      alert("Introduce un importe");
      return;
    }

    setSaving(true);
    await axios.post(`/compras/${id}/pagos`, {
      importe: Number(importe),
      fecha: fecha || null,
    });

    setImporte("");
    setFecha("");
    await load();
    setSaving(false);
  };

  if (!compra) return <div className="page-dark">Cargando…</div>;

  return (
    <div className="modal-overlay">
      <div className="modal-content modal--tall glass-box" style={{ maxWidth: 700 }}>
        
        {/* HEADER */}
        <div className="modal-header sticky-top">
          <h3 style={{ margin: 0 }}>
            Pagos de compra #{compra.numeroFactura}
          </h3>

          <button className="modal-close" onClick={() => navigate("/compras")}>
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body compact">

          <h4>Proveedor</h4>
          <p><strong>{compra.proveedorNombre}</strong></p>

          {/* RESUMEN */}
          <div style={{ marginBottom: 20 }}>
            <h4 style={{ marginBottom: 6 }}>Resumen económico</h4>

            <div className="totals-box glass-box" style={{ padding: 12 }}>
              <div>Base: <strong>{formatEuro(compra.subtotal)}</strong></div>
              <div>IVA: <strong>{formatEuro(compra.ivaTotal)}</strong></div>
              <div>Total: <strong>{formatEuro(compra.total)}</strong></div>

              <div
                style={{
                  borderTop: "1px dashed rgba(255,255,255,0.25)",
                  marginTop: 10,
                  paddingTop: 6,
                }}
              >
                Pagado: <strong>{formatEuro(totalPagado)}</strong> <br />
                Pendiente:{" "}
                <strong
                  style={{
                    color: pendiente > 0 ? "#f97373" : "#22c55e",
                    fontWeight: 700,
                  }}
                >
                  {formatEuro(pendiente)}
                </strong>
              </div>
            </div>
          </div>

          {/* PAGOS REALIZADOS */}
          <div className="section-head">
            <div className="section-title">Pagos realizados</div>
          </div>

          <div className="section-block glass-box">
            <table className="glass-table compact-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Importe</th>
                </tr>
              </thead>

              <tbody>
                {pagos.map((p) => (
                  <tr key={p.id}>
                    <td>{p.fecha ? new Date(p.fecha).toLocaleDateString() : "Sin fecha"}</td>
                    <td>{formatEuro(p.importe)}</td>
                  </tr>
                ))}

                {pagos.length === 0 && (
                  <tr>
                    <td colSpan={2} style={{ textAlign: "center", opacity: 0.6 }}>
                      Sin pagos registrados
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* NUEVO PAGO */}
          <div className="section-head" style={{ marginTop: 20 }}>
            <div className="section-title">Añadir pago</div>
          </div>

          <div className="grid-3" style={{ maxWidth: 420 }}>
            <div className="field">
              <label>Importe</label>
              <input
                type="number"
                className="glass-input"
                step="0.01"
                value={importe}
                onChange={(e) => setImporte(e.target.value)}
              />
            </div>

            <div className="field">
              <label>Fecha</label>
              <input
                type="date"
                className="glass-input"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
              />
            </div>
          </div>

          <button
            className="glass-btn"
            style={{ marginTop: 12 }}
            onClick={addPago}
            disabled={saving}
          >
            {saving ? "Guardando…" : "Guardar pago"}
          </button>
        </div>

        {/* FOOTER */}
        <div className="modal-footer sticky-bottom">
          <button
            className="glass-btn"
            onClick={() => navigate("/compras")}
          >
            Salir
          </button>
        </div>
      </div>
    </div>
  );
}
